export default {
    methods: {
        /**
         * Check if value is str. If yes, it is possible to
         * have a translation.
         * @param {string} prefix
         * @param {string|*} value
         * @returns {VueI18n.TranslateResult|*}
         */
        safeTranslateValue(prefix, value){
            if (typeof value === 'string') {
                if (this.$i18n.te(`${prefix}.${value}`)) {
                    return this.$i18n.t(`${prefix}.${value}`);
                }
            }
            return value;
        }
    }
};